import classNames from 'classnames';
import PropTypes from 'prop-types';

export const InlineLoader = ({ className, bgColor }) => {
  const loaderBits = new Array(8).fill(null);
  return (
    <div className={`absolute ${className} bg-grey-3`}>
      {loaderBits.map((_, index) => (
        <div
          key={index}
          className={classNames('absolute left-1/2 top-1/2 h-1 w-[2px] animate-hard-pulse rounded-t', bgColor)}
          style={{
            transform: `translateX(-50%) translateY(-50%) rotate(-${45 * index}deg) translateY(-8px)`,
            animationDelay: `-${index * 0.2}s`,
            opacity: 0.1125 * (8 - index) + 0.1,
          }}
        ></div>
      ))}
    </div>
  );
};

InlineLoader.propTypes = {
  className: PropTypes.string,
  bgColor: PropTypes.string,
};

InlineLoader.defaultProps = {
  className: '',
  bgColor: 'bg-white',
};
